<template>
  <Dialog :visible="visible" class="irinox-dialog-light after-sales after-sales-edit-document" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '95vw', maxWidth: '600px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{$t('afterSales.search_document.edit_document_title')}}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">


      <div class="irinox-form after-sales" >

        <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                  <label for="title">{{ $t('afterSales.upload_document.doc_title') }}</label>
                  <InputText id="title" v-model="form.title" :placeholder="$t('afterSales.upload_document.doc_title_ph')"
                    :class="{'p-invalid':v$.form.title.$invalid && submitted}"/>
              </div>
          </div>

        <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                  <label>{{ $t('afterSales.upload_document.access_type') }}</label>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.access" class="p-mr-2" inputId="access1" name="access" value="PUBLIC" 
                        :class="{'p-invalid':v$.form.access.$invalid && submitted}" />
                      <p v-html="$t('afterSales.upload_document.access_type_ALL')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.access" class="p-mr-2" inputId="access2" name="access" value="RESTRICTED" 
                        :class="{'p-invalid':v$.form.access.$invalid && submitted}" />
                      <p v-html="$t('afterSales.upload_document.access_type_RES')"></p>
                  </div>
                  <p class="light-text">{{ $t('afterSales.upload_document.access_type_description') }}</p>
              </div>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                  <label>{{ $t('afterSales.upload_document.distribution') }}</label>
                  <div class="p-field-checkbox p-my-1">
                    <Checkbox v-model="form.distributions" class="p-mr-2" :aria-label="$t('afterSales.upload_document.distribution_machine_dashboard')" name="distributions" value="machine_dashboard"
                        :class="{'p-invalid':v$.form.distributions.$invalid && submitted}"/>
                    <p v-html="$t('afterSales.upload_document.distribution_machine_dashboard')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                    <Checkbox v-model="form.distributions" class="p-mr-2" :aria-label="$t('afterSales.upload_document.distribution_generic_section')" name="distributions" value="generic_section"
                        :class="{'p-invalid':v$.form.distributions.$invalid && submitted}"/>
                    <p v-html="$t('afterSales.upload_document.distribution_generic_section')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                    <Checkbox v-model="form.distributions" class="p-mr-2" :aria-label="$t('afterSales.upload_document.distribution_external_platform')" name="distributions" value="external_platform"
                        :class="{'p-invalid':v$.form.distributions.$invalid && submitted}"/>
                    <p v-html="$t('afterSales.upload_document.distribution_external_platform')"></p>
                  </div>
              </div>
          </div>

      </div>




    </div>


    <template #footer>
      <Button :label="$t('afterSales.search_document.edit_document_button')" @click="saveDocument(!v$.form.$invalid)"/>
    </template>
  </Dialog>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('afterSales.search_document.edit_document_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('afterSales.search_document.edit_document_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import AfterSalesService from '../../service/AfterSalesService';
import { mapGetters } from 'vuex';
export default {
    components: {
      IrinoxDialogDark
    },
    setup: () => ({ v$: useVuelidate() }),
    emits: ['update:visible','saved:document'],
    props: {
      visible: Boolean,
      documentId: Number,
      title: String,
      access: String,
      distributions: Array,
    },
    data() {
        return {
          form: {
            title: null,
            access: null,
            distributions: [],
          },
          dialog: {
            error: false,
            success: false,
          },
          submitted: false,
        };
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
      }),
    },
    validations() {
      return {
          form: {
            title: {
                required
            },
            access: {
                required
            },
            distributions: {
                required,
            },
          }
      }
    },
    watch: {
    },
    created() {
      this.afterSalesService = new AfterSalesService();
    },
    mounted() {
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.form = {
            title: this.$functions.clone(this.title),
            access: this.$functions.clone(this.access),
            distributions: this.$functions.clone(this.distributions),
          };
        }
        this.$emit("update:visible", value);
      },
      show() {
        this.form = {
          title: this.$functions.clone(this.title),
          access: this.$functions.clone(this.access),
          distributions: this.$functions.clone(this.distributions),
        };
      },
      saveDocument(isFormValid) {
        this.submitted = true;
        if (!isFormValid) {
          return;
        }
        let formCopy = this.$functions.clone(this.form);
        this.afterSalesService.patchDocument(this.personaltoken, this.documentId, formCopy)
            .then((data) => {
              if(data.code=="200") {
                this.dialog.success = true;
                this.$emit("saved:document");
              } else {
                console.error(JSON.stringify(data));
                this.dialog.error = true;
              }
              })
            .catch(error => {
              console.error("ERROR "+error);
              this.dialog.error = true;
            });
      },
    }
}
</script>

<style>

</style>